
import { useParams } from "react-router-dom";
import JobSingle2 from "./JobSingle2";
// import JobReview2 from "../../../features/employerDashboard/components/JobDetail";

export function PublicJobDetailPage() {
    const { uuid } = useParams();
    return (
      <div>
        <JobSingle2 uuid={uuid} />
      </div>
    );
  }